'use strict';

// v 1.0.8


// Связь с сервером)
const Options = {
  action: '',
  data: undefined,
  type: 'json' || 'text' || 'blob',
  headers: {},
  method: 'GET' || 'POST'
};
export function http(options = Options) {
  // const controller = new AbortController();
  // const signal = controller.signal;

  const settings = {
    method: 'GET',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      ...options.headers
    },
    body: undefined,
    mode: 'cors',
    cache: 'no-store'
    // signal
  };

  if (options.data) {
    settings.method = 'POST';
    settings.body = options.data;
  }

  if (options.method) settings.method = options.method;

  if (settings.method !== 'POST') {
    settings.headers['Content-type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
  }


  const f = fetch(options.action, settings);
  if (options.type === 'blob') {
    return f.then(response => response.blob());
  } else if (options.type === 'text') {
    return f.then(response => response.text());
  } else {
    return f.then(response => response.json());
  }

  // return controller;
}

export function queryParse(str) {
  if (typeof str !== 'string') {
    return {};
  }

  str = str.trim().replace(/^(\?|#|&)/, '');

  if (!str) {
    return {};
  }

  return str.split('&').reduce(function (ret, param) {
    let parts = param.replace(/\+/g, ' ').split('=');
    let key = parts[0];
    let val = parts[1];

    key = decodeURIComponent(key);

    // missing `=` should be `null`:
    // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
    val = val === undefined ? null : decodeURIComponent(val);

    if (!ret.hasOwnProperty(key)) {
      ret[key] = val;
    } else if (Array.isArray(ret[key])) {
      ret[key].push(val);
    } else {
      ret[key] = [ret[key], val];
    }

    return ret;
  }, {});
}


// Класс для сторов
export class EventEmitter {
  constructor() {
    this.handlers = [];
  }

  dispatch() {
    for (const argument of arguments) {
      this.handlers.forEach(handler => handler(argument));
    }
  }
  subscribe(handler) {
    if (!this.handlers.includes(handler)) this.handlers.push(handler);

    return this;
  }
  unsubscribe(handler) {
    const index = this.handlers.indexOf(handler);

    if (index >= 0) this.handlers.splice(index, 1);

    return this;
  }
}

// линки
export function addHint(type, url) {
  if (!type || !url) return;

  let el = document.createElement('link');
  el.setAttribute('rel', type);
  el.setAttribute('href', url);
  document.getElementsByTagName('head')[0].appendChild(el);
}

// Возвращает значение CSS элемента
export function getCSS(element, property) {
  return window.getComputedStyle(element, null).getPropertyValue(property);
}

// Четное / нечетное
export const even = n => !(n % 2);

// Проверка на тач
export function isTouch() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
}

export function base64ToArrayBuffer(base64) {
  base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
  let binaryString = atob(base64);
  let len = binaryString.length;
  let bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

export function randomSort() {
  return 0.5 - Math.random();
}

export function randomInteger(min, max) {
  let rand = min - 0.5 + Math.random() * (max - min + 1);
  rand = Math.round(rand);
  return rand;
}

export function checkIE() {
  let match = navigator.userAgent.match(/(?:MSIE |Trident\/.*; rv:)(\d+)/);
  return match ? parseInt(match[1]) : undefined;
}

// Размеры элемента
export function offset(elem) {
  function getOffsetSum(elem) {
    let top = 0, left = 0;
    while (elem) {
      top = top + parseInt(elem.offsetTop);
      left = left + parseInt(elem.offsetLeft);
      elem = elem.offsetParent;
    }

    return {top: top, left: left};
  }

  function getOffsetRect(elem) {
    let box = elem.getBoundingClientRect();

    let body = document.body;
    let docElem = document.documentElement;

    let scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop;
    let scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft;

    let clientTop = docElem.clientTop || body.clientTop || 0;
    let clientLeft = docElem.clientLeft || body.clientLeft || 0;

    let top = box.top + scrollTop - clientTop;
    let left = box.left + scrollLeft - clientLeft;

    return {
      top: Math.round(top),
      left: Math.round(left)
    };
  }

  if (elem.getBoundingClientRect) {
    return getOffsetRect(elem);
  } else {
    return getOffsetSum(elem);
  }
}

// Modernizr
const domPrefixes = ['moz', 'o', 'ms', 'webkit'];

export function prefixedCSSValue(prop, value) {
  let result = false;
  let elem = document.createElement('div');
  let style = elem.style;

  if (prop in style) {
    let i = domPrefixes.length;

    style[prop] = value;
    result = style[prop];

    while (i-- && !result) {
      style[prop] = '-' + domPrefixes[i] + '-' + value;
      result = style[prop];
    }
  }

  if (result === '') {
    result = false;
  }

  return result;
}

export function getPolygonPoints(path, s) {
  let curve = MorphSVGPlugin.pathDataToBezier(path);
  if (!s) s = 1;

  let arr = [];
  for (let i = 0; curve.length > i; i++) {
    arr.push(curve[i].x * s, curve[i].y * s);
  }
  return arr;
}

export function setCoverScale(pw, ph, cw, ch) {
  if (pw / ph > cw / ch) {
    return pw / cw;
  } else {
    return ph / ch;
  }
}
export function setContainScale(pw, ph, cw, ch) {
  if (pw / ph > cw / ch) {
    return ph / ch;
  } else {
    return pw / cw;
  }
}

// Работа с куки
export class Cookie {
  constructor () {

  }
  get (name) {
    let matches = document.cookie.match(new RegExp(
      '(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }

  set (name, value, options) {
    options = options || {};

    let expires = options.expires;

    if (typeof expires === 'number' && expires) {
      let d = new Date();
      d.setTime(d.getTime() + expires * 1000);
      expires = options.expires = d;
    }
    if (expires && expires.toUTCString) {
      options.expires = expires.toUTCString();
    }

    value = encodeURIComponent(value);

    let updatedCookie = name + '=' + value;

    for (let propName in options) {
      if (options.hasOwnProperty(propName)) {
        updatedCookie += '; ' + propName;
        let propValue = options[propName];
        if (propValue !== true) {
          updatedCookie += '=' + propValue;
        }
      }
    }

    document.cookie = updatedCookie;
  }

  delete (name) {
    this.set(name, '', {
      expires: -1
    })
  }
}


export function declension(digit, expr, onlyword) {
  digit = digit + '';
  let res = '';

  let expr_list = expr.split(' ');

  let reg = /[^0-9]+/;
  let i = digit.replace(reg, '');

  if (onlyword) digit = '';

  if (i >= 5 && i <= 20) res = digit + ' ' + expr_list[2];

  else {
    i %= 10;
    if (i === 1) res = digit + ' ' + expr_list[0];
    else if (i >= 2 && i <= 4) res = digit + ' ' + expr_list[1];
    else res = digit + ' ' + expr_list[2];
  }

  return res;
}


export function debounce(f, ms) {
  let state = null,
    COOLDOWN = 1;

  return function () {
    if (state) return;

    f.apply(this, arguments);

    state = COOLDOWN;

    setTimeout(function () {
      state = null
    }, ms);
  }
}

export function throttle(func, ms) {
  let isThrottled = false,
    savedArgs,
    savedThis;

  function wrapper() {

    if (isThrottled) {
      savedArgs = arguments;
      savedThis = this;
      return;
    }

    func.apply(this, arguments);

    isThrottled = true;

    setTimeout(function () {
      isThrottled = false;
      if (savedArgs) {
        wrapper.apply(savedThis, savedArgs);
        savedArgs = savedThis = null;
      }
    }, ms);
  }

  return wrapper;
}



export class Text {
  constructor(text, style, stroke) {
    this._canvas = document.createElement('canvas');
    this._context = this._canvas.getContext('2d');
    this._data = null;

    this._text = text || 'nothing';
    this._style = {
      fontSize: 14,
      lineHeight: 20,
      letterSpacing: 0,
      fontFamily: 'sans-serif',
      color: '#000',
      y: 0
    };
    this._font = this._style.fontSize + 'px ' + this._style.fontFamily;

    this._width = 10;
    this._height = 10;

    if (stroke) {
      this._strokeWidth = stroke.width || 1;
      this._strokeColor = stroke.color || '#000';
      this._draw = () => this._stroke();
    } else {
      this._draw = () => this._fill();
    }

    this._resize();
  }
  get data() {
    return this._data;
  }
  set text(text) {
    if (!text || typeof text !== 'string' || this._text === text) return;

    this._text = text;

    this._resize();
  }
  set style(style) {
    if (!style || typeof style !== 'object') return;

    let change = false;

    for (let key in this._style) {
      if (this._style.hasOwnProperty(key) && style.hasOwnProperty(key) && this._style[key] !== style[key]) {
        this._style[key] = style[key];
        change = true;
      }
    }


    this._font = this._style.fontSize + 'px ' + this._style.fontFamily;

    if (!change) return;

    this._resize();
  }

  _resize() {
    this._context.font = this._font;
    this._width = Math.ceil(this._context.measureText(this._text).width) + this._style.letterSpacing * this._text.length;
    this._height = this._style.lineHeight;

    this._canvas.width = this._width;
    this._canvas.height = this._height;

    this._draw();
  }

  _fill(){
    this._context.clearRect(0, 0, this._width, this._height);
    this._context.font = this._font;
    this._context.textBaseline = 'top';
    this._context.fillStyle = this._style.color;

    let wAll = this._context.measureText(this._text).width;
    let char, wShorter, wChar;

    let x = 0;
    let y = this._style.y;
    let text = this._text;

    do{
      char = text.substr(0, 1);
      text = text.substr(1);
      this._context.fillText(char, x, y);

      wShorter = text === '' ? 0 : this._context.measureText(text).width;


      wChar = wAll - wShorter;

      x += wChar + this._style.letterSpacing;
      wAll = wShorter;
    } while (text !== '');

    this._data = this._context.getImageData(0, 0, this._width, this._height);
  }
  _stroke(){
    this._context.clearRect(0, 0, this._width, this._height);
    this._context.font = this._font;
    this._context.textBaseline = 'top';
    this._context.lineWidth = this._strokeWidth;
    this._context.strokeStyle = this._strokeColor;

    let wAll = this._context.measureText(this._text).width;
    let char, wShorter, wChar;

    let x = 0;
    let y = this._style.y;
    let text = this._text;


    do{
      char = text.substr(0, 1);
      text = text.substr(1);
      this._context.strokeText(char, x, y);

      wShorter = text === '' ? 0 : this._context.measureText(text).width;


      wChar = wAll - wShorter;

      x += wChar + this._style.letterSpacing;
      wAll = wShorter;
    } while (text !== '');

    this._data = this._context.getImageData(0, 0, this._width, this._height);
  }
}